import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { prettyNumber } from '../../../utils/helpers';
import {
  AgencyHead,
  AgencyHeaderContainer,
  AgencyHeaderInfo,
  AgencyHeaderLogo,
  AgencyInfoViews,
  AgencyTitle,
  InfoViewContainer
} from './styled';
import { ReadMore } from '../../Ad/ReadMore';

interface AgencyHeaderProps {
  title: string;
  views: number;
  apartmentCount: number;
  logoUrl?: string;
  description: string;
}

export const AgencyHeader: React.FC<AgencyHeaderProps> = memo(
  ({ title, views = 0, apartmentCount = 0, logoUrl, description }) => {
    const { t } = useTranslation();

    const prettyViews = useMemo(() => prettyNumber(views), [views]);
    const prettyApartmentCount = useMemo(
      () => prettyNumber(apartmentCount),
      [views]
    );

    return (
      <AgencyHeaderContainer>
        <AgencyHead>
          {logoUrl && (
            <AgencyHeaderLogo
              src={logoUrl}
              width={80}
              height={80}
              data-cy="agency-header__logo"
              alt={t('pages.agency.logo', {
                name: title
              })}
            />
          )}
          <AgencyHeaderInfo data-cy="agency-header__info">
            <AgencyTitle tag="h1" data-cy="agency-header__info-title">
              {t('pages.agency.title', { name: title })}
            </AgencyTitle>
            <InfoViewContainer>
              <AgencyInfoViews tag="body_2" data-cy="agency-header__info-views">
                {t('pages.agency.views', { views_count: prettyViews })}
              </AgencyInfoViews>
              <AgencyInfoViews tag="body_2" data-cy="agency-header__info-views">
                {t('pages.agency.offers', {
                  apartment_count: prettyApartmentCount
                })}
              </AgencyInfoViews>
            </InfoViewContainer>
          </AgencyHeaderInfo>
        </AgencyHead>

        <ReadMore description={description} />
      </AgencyHeaderContainer>
    );
  }
);

AgencyHeader.displayName = 'AgencyHeader';
